<template>
  <div
    v-if="contentList?.length || authors?.length"
    class="top-[95px] col-span-1 hidden h-fit w-full max-w-[367px] overflow-y-hidden rounded-[12px] px-6 py-7 font-medium shadow-drop-2 lg:row-span-1 lg:block xl:row-span-1"
    :class="{ sticky: contentList?.length }"
  >
    <template v-if="contentList?.length">
      <h3
        class="mb-[20px] font-roboto text-[20px] font-medium leading-[24px] text-new-test-black"
      >
        Содержание лекции
      </h3>
      <ul
        class="custom-scrollbar max-h-[70vh] list-disc overflow-y-scroll text-[#4d4d4d]"
      >
        <li
          v-for="(item, index) in contentList"
          :key="`toc-item-${item.offset}-${index}`"
          class="mb-[20px] ml-[16px] cursor-pointer font-roboto text-[14px] font-medium leading-[17px] last:mb-0"
          :class="{
            'text-collection': index === currentActive,
          }"
          @click="emit('on-active', index)"
        >
          <p>
            {{ item.title }}
          </p>
        </li>
      </ul>
    </template>
    <div
      v-if="authors.length"
      class="pb-5"
      :class="{ 'mt-6 pt-5': contentList?.length }"
    >
      <h3
        class="mb-[20px] font-roboto text-[20px] font-medium leading-[24px] text-new-test-black"
      >
        Авторы
      </h3>
      <div class="author font-roboto text-[14px] font-bold leading-[17px]">
        <span v-for="(author, index) in authors" :key="index">{{
          author.fullname
        }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  contentList: {
    type: Array,
    default: () => [],
  },
  authors: {
    type: Array,
    default: () => [],
  },
  currentActive: {
    type: Number,
    default: 0,
  },
});
const emit = defineEmits(['on-active']);
</script>

<style lang="scss" scoped>
.author {
  padding-left: 20px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: #a10009;
    left: 0;
    top: 50%;
    transform: translateY(-60%);
  }
}
</style>
